import React from 'react'

// MU stuff
import { makeStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100vh',
    margin: 'auto'
  },

  logoImg: {
    width: '20%'

  }
}))

export default function LoadingPage () {
  const classes = useStyles()
  return (
    <Grid container justify="center" alignItems="center" className={classes.container} >
      <img className={classes.logoImg} src="https://firebasestorage.googleapis.com/v0/b/application-x-a2ba8.appspot.com/o/logo512.png?alt=media&token=4de8bdc7-85cd-4d4b-884f-65089d490103" alt='logo' />
    </Grid>
  )
}
